<template>
  <transition name="transition">
    <div
      class="photo-viewer"
      v-if="isShown"
    >
      <button
        class="
          photo-viewer__btn-close
          app__button-raised
        "
        @click="closeSelf"
      >
        <i class="photo-viewer__icon-close mdi mdi-close" />
      </button>
      <div
        class="photo-viewer__img-wrp"
      >
        <img
          class="photo-viewer__img"
          @click="closeSelf"
          :src="imgUrl"
        >
      </div>
    </div>
  </transition>
</template>

<script>
const EVENTS = {
  updateIsShown: 'update:isShown',
}

export default {
  name: 'photo-viewer',
  props: {
    imgUrl: {
      type: String,
      required: true,
    },
    isShown: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    closeSelf () {
      this.$emit(EVENTS.updateIsShown, false)
    },
  },
}
</script>

<style lang="scss">
@import '~@scss/variables';
@import '~@scss/mixins';

.photo-viewer {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  overflow: hidden;
  background: $col-photo-viewer-bg;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: $z-index-photo-viewer;

  &__btn-close {
    position: absolute;
    width: 5rem;
    height: 5rem;
    top: 2rem;
    right: 2rem;

    @include respond-to($medium) {
      display: none;
    }
  }

  &__icon-close {
    font-size: 2.2rem;
  }

  &__img-wrp {
    padding: 5rem 10rem;

    @include respond-to($x-medium) {
      padding: 2.5rem 5rem;
    }
    @include respond-to($medium) {
      padding: 2.5rem 2rem;
    }
  }

  &__img {
    width: 100%;
    height: auto;
    cursor: pointer;
  }
}

.transition-enter-active {
  animation: viewer-appear-keyframe 0.2s ease-in-out;
}

.transition-leave-active {
  animation: viewer-disappear-keyframe 0.2s ease-in-out;
}

@keyframes viewer-appear-keyframe {
  from { opacity: 0; }
  to { opacity: 1; }
}
@keyframes viewer-disappear-keyframe {
  from { opacity: 1; }
  to { opacity: 0; }
}
</style>
